import styled from '@emotion/styled'
import { spacing } from 'main/ui'

export const AppFeaturesContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: ${spacing.majorScale(4)}px 0;
`
